// To check if device is Android
export const isAndroidDevice = (): boolean =>
  /(android)/i.test(navigator.userAgent);
